
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contents/search",
      function () {
        return require("private-next-pages/contents/search.tsx");
      }
    ]);
  